export default __webpack_public_path__ + "static/profession-has-no-gender-header-0b363837ecdcee6b3a695d6228e7e177.svg";